var cov_1duya60175 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Alert/index.tsx",
      hash = "88d765b4798f14c25f0615dc4ce9cd54dbbb754f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Alert/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 16
        }
      },
      "2": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      "3": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 42
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 42
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 50
        }
      },
      "7": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      },
      "8": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 24
        }
      },
      "9": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "10": {
        start: {
          line: 50,
          column: 24
        },
        end: {
          line: 50,
          column: 34
        }
      },
      "11": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 33
        }
      },
      "12": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 54,
          column: 5
        }
      },
      "13": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 15
        }
      },
      "14": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 38
        }
      },
      "15": {
        start: {
          line: 58,
          column: 32
        },
        end: {
          line: 58,
          column: 38
        }
      },
      "16": {
        start: {
          line: 59,
          column: 72
        },
        end: {
          line: 59,
          column: 82
        }
      },
      "17": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "18": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 65,
          column: 7
        }
      },
      "19": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 52
        }
      },
      "20": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 12
        }
      },
      "21": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "22": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 72,
          column: 8
        }
      },
      "23": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 42
        }
      },
      "24": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 20
        }
      },
      "25": {
        start: {
          line: 79,
          column: 19
        },
        end: {
          line: 79,
          column: 29
        }
      },
      "26": {
        start: {
          line: 80,
          column: 75
        },
        end: {
          line: 80,
          column: 85
        }
      },
      "27": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      "28": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 58
        }
      },
      "29": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 26
        }
      },
      "30": {
        start: {
          line: 86,
          column: 15
        },
        end: {
          line: 86,
          column: 26
        }
      },
      "31": {
        start: {
          line: 87,
          column: 33
        },
        end: {
          line: 87,
          column: 97
        }
      },
      "32": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "33": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 42
        }
      },
      "34": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 30
        }
      },
      "35": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "36": {
        start: {
          line: 101,
          column: 26
        },
        end: {
          line: 101,
          column: 36
        }
      },
      "37": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 103,
          column: 87
        }
      },
      "38": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 87
        }
      },
      "39": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "40": {
        start: {
          line: 112,
          column: 24
        },
        end: {
          line: 112,
          column: 34
        }
      },
      "41": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 34
        }
      },
      "42": {
        start: {
          line: 113,
          column: 23
        },
        end: {
          line: 113,
          column: 34
        }
      },
      "43": {
        start: {
          line: 115,
          column: 76
        },
        end: {
          line: 115,
          column: 86
        }
      },
      "44": {
        start: {
          line: 116,
          column: 17
        },
        end: {
          line: 116,
          column: 34
        }
      },
      "45": {
        start: {
          line: 118,
          column: 22
        },
        end: {
          line: 118,
          column: 32
        }
      },
      "46": {
        start: {
          line: 119,
          column: 22
        },
        end: {
          line: 119,
          column: 43
        }
      },
      "47": {
        start: {
          line: 120,
          column: 24
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "48": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 51
        }
      },
      "49": {
        start: {
          line: 128,
          column: 19
        },
        end: {
          line: 128,
          column: 51
        }
      },
      "50": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "51": {
        start: {
          line: 140,
          column: 0
        },
        end: {
          line: 140,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 33
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 44
          },
          end: {
            line: 41,
            column: 3
          }
        },
        line: 37
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 30
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 12
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        loc: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 57
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 70,
            column: 36
          },
          end: {
            line: 70,
            column: 37
          }
        },
        loc: {
          start: {
            line: 70,
            column: 42
          },
          end: {
            line: 72,
            column: 7
          }
        },
        line: 70
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        loc: {
          start: {
            line: 78,
            column: 15
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 16
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 100
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 11
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 111
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }],
        line: 38
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 48
          }
        }, {
          start: {
            line: 38,
            column: 52
          },
          end: {
            line: 38,
            column: 70
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 54,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 54,
            column: 5
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 54,
            column: 5
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 38
          }
        }, {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 38
          }
        }],
        line: 58
      },
      "4": {
        loc: {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 59,
            column: 23
          },
          end: {
            line: 59,
            column: 44
          }
        }],
        line: 59
      },
      "5": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 62
      },
      "6": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }, {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 65,
            column: 7
          }
        }],
        line: 63
      },
      "7": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 69
      },
      "8": {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 80,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 80,
            column: 19
          },
          end: {
            line: 80,
            column: 36
          }
        }],
        line: 80
      },
      "9": {
        loc: {
          start: {
            line: 80,
            column: 38
          },
          end: {
            line: 80,
            column: 70
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 80,
            column: 49
          },
          end: {
            line: 80,
            column: 70
          }
        }],
        line: 80
      },
      "10": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }],
        line: 82
      },
      "11": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 33
          }
        }, {
          start: {
            line: 82,
            column: 37
          },
          end: {
            line: 82,
            column: 41
          }
        }],
        line: 82
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 26
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 86,
            column: 26
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }],
        line: 88
      },
      "14": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 103,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 103,
            column: 87
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 103,
            column: 87
          }
        }],
        line: 102
      },
      "15": {
        loc: {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 106,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 106,
            column: 18
          }
        }, {
          start: {
            line: 106,
            column: 22
          },
          end: {
            line: 106,
            column: 33
          }
        }],
        line: 106
      },
      "16": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 34
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 34
          }
        }],
        line: 113
      },
      "17": {
        loc: {
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 29
          }
        }, {
          start: {
            line: 119,
            column: 33
          },
          end: {
            line: 119,
            column: 43
          }
        }],
        line: 119
      },
      "18": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 19
          }
        }, {
          start: {
            line: 123,
            column: 23
          },
          end: {
            line: 123,
            column: 36
          }
        }, {
          start: {
            line: 123,
            column: 40
          },
          end: {
            line: 123,
            column: 51
          }
        }],
        line: 123
      },
      "19": {
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 15
          }
        }, {
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 124,
            column: 31
          }
        }],
        line: 124
      },
      "20": {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 125,
            column: 10
          }
        }, {
          start: {
            line: 125,
            column: 14
          },
          end: {
            line: 125,
            column: 25
          }
        }],
        line: 125
      },
      "21": {
        loc: {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 126,
            column: 13
          }
        }, {
          start: {
            line: 126,
            column: 17
          },
          end: {
            line: 126,
            column: 22
          }
        }],
        line: 126
      },
      "22": {
        loc: {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 128,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 128,
            column: 51
          }
        }, {
          start: {
            line: 128,
            column: 4
          },
          end: {
            line: 128,
            column: 51
          }
        }],
        line: 128
      },
      "23": {
        loc: {
          start: {
            line: 132,
            column: 9
          },
          end: {
            line: 132,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 9
          },
          end: {
            line: 132,
            column: 18
          }
        }, {
          start: {
            line: 132,
            column: 22
          },
          end: {
            line: 132,
            column: 40
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Alert/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import { isRTL } from '../config';
import { alertClass } from './styles';
import { capitalize } from '../utils/strings';
import { defaultProps } from '../utils/defaultProps';
var DefaultProps = (cov_1duya60175.s[0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  iconSize: 16,
  duration: 200,
  type: 'warning'
}));

var Alert =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Alert, _PureComponent);

  var _super = _createSuper2(Alert);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    cov_1duya60175.f[0]++;
    cov_1duya60175.s[1]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    cov_1duya60175.s[2]++;
    _this.state = {
      dismiss: 0
    };
    cov_1duya60175.s[3]++;
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
    cov_1duya60175.s[4]++;
    _this.dismiss = _this.dismiss.bind(_assertThisInitialized(_this));
    cov_1duya60175.s[5]++;
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    cov_1duya60175.s[6]++;
    _this.renderClose = _this.renderClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Alert, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_1duya60175.f[1]++;
      cov_1duya60175.s[7]++;

      if ((cov_1duya60175.b[1][0]++, this.props.dismiss !== prevProps.dismiss) && (cov_1duya60175.b[1][1]++, this.props.dismiss)) {
        cov_1duya60175.b[0][0]++;
        cov_1duya60175.s[8]++;
        this.handleClose();
      } else {
        cov_1duya60175.b[0][1]++;
      }
    }
  }, {
    key: "bindRef",
    value: function bindRef(el) {
      cov_1duya60175.f[2]++;
      cov_1duya60175.s[9]++;
      this.element = el;
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      cov_1duya60175.f[3]++;

      var _ref = (cov_1duya60175.s[10]++, this.props),
          onClose = _ref.onClose;

      cov_1duya60175.s[11]++;
      this.setState({
        dismiss: 2
      });
      cov_1duya60175.s[12]++;

      if (typeof onClose === 'function') {
        cov_1duya60175.b[2][0]++;
        cov_1duya60175.s[13]++;
        onClose();
      } else {
        cov_1duya60175.b[2][1]++;
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this2 = this;

      cov_1duya60175.f[4]++;
      cov_1duya60175.s[14]++;

      if (this.state.dismiss > 0) {
        cov_1duya60175.b[3][0]++;
        cov_1duya60175.s[15]++;
        return;
      } else {
        cov_1duya60175.b[3][1]++;
      }

      var _ref2 = (cov_1duya60175.s[16]++, this.props),
          _ref2$duration = _ref2.duration,
          duration = _ref2$duration === void 0 ? (cov_1duya60175.b[4][0]++, DefaultProps.duration) : _ref2$duration,
          outAnimation = _ref2.outAnimation,
          onClose = _ref2.onClose; // outer animation


      cov_1duya60175.s[17]++;

      if (outAnimation) {
        cov_1duya60175.b[5][0]++;
        cov_1duya60175.s[18]++;

        if (typeof onClose === 'function') {
          cov_1duya60175.b[6][0]++;
          cov_1duya60175.s[19]++;
          onClose(duration, this.element.offsetHeight);
        } else {
          cov_1duya60175.b[6][1]++;
        }

        cov_1duya60175.s[20]++;
        return;
      } else {
        cov_1duya60175.b[5][1]++;
      }

      cov_1duya60175.s[21]++;

      if (duration > 0) {
        cov_1duya60175.b[7][0]++;
        cov_1duya60175.s[22]++;
        this.setState({
          dismiss: 1
        }, function () {
          cov_1duya60175.f[5]++;
          cov_1duya60175.s[23]++;
          setTimeout(_this2.dismiss, duration);
        });
      } else {
        cov_1duya60175.b[7][1]++;
        cov_1duya60175.s[24]++;
        this.dismiss();
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      cov_1duya60175.f[6]++;

      var _ref3 = (cov_1duya60175.s[25]++, this.props),
          icon = _ref3.icon;

      var _ref4 = (cov_1duya60175.s[26]++, this.props),
          _ref4$type = _ref4.type,
          type = _ref4$type === void 0 ? (cov_1duya60175.b[8][0]++, DefaultProps.type) : _ref4$type,
          _ref4$iconSize = _ref4.iconSize,
          iconSize = _ref4$iconSize === void 0 ? (cov_1duya60175.b[9][0]++, DefaultProps.iconSize) : _ref4$iconSize;

      cov_1duya60175.s[27]++;

      if ((cov_1duya60175.b[11][0]++, typeof icon === 'boolean') && (cov_1duya60175.b[11][1]++, icon)) {
        cov_1duya60175.b[10][0]++;
        cov_1duya60175.s[28]++;
        icon = icons[capitalize(type)];
      } else {
        cov_1duya60175.b[10][1]++;
      }

      cov_1duya60175.s[29]++;

      if (!icon) {
        cov_1duya60175.b[12][0]++;
        cov_1duya60175.s[30]++;
        return null;
      } else {
        cov_1duya60175.b[12][1]++;
      }

      var style = (cov_1duya60175.s[31]++, {
        width: iconSize,
        height: iconSize,
        marginRight: iconSize / 2
      });
      cov_1duya60175.s[32]++;

      if (isRTL()) {
        cov_1duya60175.b[13][0]++;
        cov_1duya60175.s[33]++;
        style.marginLeft = style.marginRight;
        cov_1duya60175.s[34]++;
        delete style.marginRight;
      } else {
        cov_1duya60175.b[13][1]++;
      }

      cov_1duya60175.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: alertClass('icon'),
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 94,
            columnNumber: 7
          }
        }, icon)
      );
    }
  }, {
    key: "renderClose",
    value: function renderClose() {
      cov_1duya60175.f[7]++;

      var _ref5 = (cov_1duya60175.s[36]++, this.props),
          closeItem = _ref5.closeItem;

      cov_1duya60175.s[37]++;

      if (
      /*#__PURE__*/
      React.isValidElement(closeItem)) {
        cov_1duya60175.b[14][0]++;
        cov_1duya60175.s[38]++;
        return (
          /*#__PURE__*/
          React.cloneElement(closeItem, {
            onClick: this.handleClose
          })
        );
      } else {
        cov_1duya60175.b[14][1]++;
      }

      cov_1duya60175.s[39]++;
      return (
        /*#__PURE__*/
        React.createElement("a", {
          className: alertClass('close'),
          onClick: this.handleClose,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 105,
            columnNumber: 7
          }
        }, (cov_1duya60175.b[15][0]++, closeItem) || (cov_1duya60175.b[15][1]++, icons.Close))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1duya60175.f[8]++;

      var _ref6 = (cov_1duya60175.s[40]++, this.state),
          dismiss = _ref6.dismiss;

      cov_1duya60175.s[41]++;

      if (dismiss === 2) {
        cov_1duya60175.b[16][0]++;
        cov_1duya60175.s[42]++;
        return null;
      } else {
        cov_1duya60175.b[16][1]++;
      }

      var _ref7 = (cov_1duya60175.s[43]++, this.props),
          children = _ref7.children,
          className = _ref7.className,
          type = _ref7.type,
          onClose = _ref7.onClose,
          outAnimation = _ref7.outAnimation,
          hideClose = _ref7.hideClose;

      var icon = (cov_1duya60175.s[44]++, this.renderIcon());

      var _ref8 = (cov_1duya60175.s[45]++, this.props),
          style = _ref8.style;

      var showClose = (cov_1duya60175.s[46]++, (cov_1duya60175.b[17][0]++, onClose) && (cov_1duya60175.b[17][1]++, !hideClose));
      var wrapClassName = (cov_1duya60175.s[47]++, alertClass('_', type, (cov_1duya60175.b[18][0]++, !outAnimation) && (cov_1duya60175.b[18][1]++, dismiss === 1) && (cov_1duya60175.b[18][2]++, 'dismissed'), (cov_1duya60175.b[19][0]++, showClose) && (cov_1duya60175.b[19][1]++, 'with-close'), (cov_1duya60175.b[20][0]++, icon) && (cov_1duya60175.b[20][1]++, 'with-icon'), (cov_1duya60175.b[21][0]++, isRTL()) && (cov_1duya60175.b[21][1]++, 'rtl')));
      cov_1duya60175.s[48]++;

      if (className) {
        cov_1duya60175.b[22][0]++;
        cov_1duya60175.s[49]++;
        wrapClassName += " ".concat(className);
      } else {
        cov_1duya60175.b[22][1]++;
      }

      cov_1duya60175.s[50]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindRef,
          className: wrapClassName,
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 131,
            columnNumber: 7
          }
        }, (cov_1duya60175.b[23][0]++, showClose) && (cov_1duya60175.b[23][1]++, this.renderClose()), icon,
        /*#__PURE__*/
        React.createElement("div", {
          className: alertClass('content'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134,
            columnNumber: 9
          }
        }, children))
      );
    }
  }]);

  return Alert;
}(PureComponent);

Alert.defaultProps = DefaultProps;
Alert.displayName = void 0;
cov_1duya60175.s[51]++;
Alert.displayName = 'ShineoutAlert';
export default Alert;